import { Link, useLocation } from "react-router-dom";
import { useContext, useState } from "react";
import Cookies from "js-cookie";
import { APP_NAME } from "./config";
import { auth } from "./firebase";
import { signOut } from "firebase/auth";
import { AuthContext } from "./AuthContext";

const Navbar = ({ profileImage, toggleSidebar }) => {
  const location = useLocation();
  const { logout } = useContext(AuthContext);
  const [isFullScreen, setIsFullScreen] = useState(false);

  // Generate the fallback avatar only once
  const [avatarUrl] = useState(
    () =>
      profileImage ||
      `https://api.dicebear.com/7.x/avataaars/svg?seed=${Math.random()
        .toString(36)
        .substring(7)}&backgroundColor=b6e3f4,c0aede,d1d4f9&radius=50`
  );

  // Breadcrumb builder
  const pathParts = location.pathname
    .split("/")
    .filter((part) => part && part !== "overview");

  const toggleFullScreen = () => {
    const elem = document.documentElement;

    if (!document.fullscreenElement) {
      elem
        .requestFullscreen()
        .then(() => setIsFullScreen(true))
        .catch((err) => console.error(`Fullscreen error: ${err.message}`));
    } else {
      document.exitFullscreen();
      setIsFullScreen(false);
    }
  };

  return (
    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
      {/* Sidebar Toggle (Topbar) */}
      <button
        id="sidebarToggleTop"
        className="btn btn-link d-md-none rounded-circle mr-3"
        onClick={toggleSidebar}
      >
        <i className="fa fa-bars" />
      </button>
      <div className="d-none d-md-block">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to="/overview">Overview</Link>
            </li>

            {pathParts.map((part, index) => {
              const fullPath = "/" + pathParts.slice(0, index + 1).join("/");
              const isLast = index === pathParts.length - 1;

              return (
                <li
                  key={fullPath}
                  className={`breadcrumb-item ${isLast ? "active" : ""}`}
                  aria-current={isLast ? "page" : undefined}
                >
                  {isLast ? (
                    part.charAt(0).toUpperCase() + part.slice(1)
                  ) : (
                    <Link to={fullPath}>
                      {part.charAt(0).toUpperCase() + part.slice(1)}
                    </Link>
                  )}
                </li>
              );
            })}
          </ol>
        </nav>
      </div>

      {/* Topbar Navbar */}
      <ul className="navbar-nav ml-auto">
        {/* Alerts, User Menu, etc. */}

        <li
          className="nav-item dropdown no-arrow mx-1"
          data-toggle="tooltip"
          data-original-title="Full Screen"
        >
          <a className="nav-link" href="#" onClick={toggleFullScreen}>
            <i
              className={`fas ${
                isFullScreen ? "fa-compress" : "fa-expand"
              } fa-fw`}
            />
          </a>
        </li>

        <div className="topbar-divider d-none d-sm-block" />

        {/* User Info */}
        <li className="nav-item dropdown no-arrow">
          <a
            className="nav-link dropdown-toggle"
            href="#"
            id="userDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span className="mr-2 d-none d-lg-inline text-gray-600 small"></span>
            <img src={avatarUrl} alt="avatar" width={40} />
          </a>
          <div
            className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
            aria-labelledby="userDropdown"
          >
            <Link className="dropdown-item" to={"/account"}>
              <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400" />
              Account settings
            </Link>

            <div className="dropdown-divider" />
            <button className="dropdown-item" onClick={logout}>
              <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400" />
              Logout
            </button>
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
